import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Route, Switch } from 'react-router-dom';

import { getCurrentUser } from 'modules/user';
// import { formatMoney } from 'utils/formatMoney';

// import LoadingOverlay from 'components/LoadingOverlay';
import FundAmount from './FundAmount';
import PayoutHistory from './PayoutHistory';

class FundsPage extends Component {
	static propTypes = {
		dispatch: PropTypes.func.isRequired,
		isFundLoading: PropTypes.bool.isRequired
	};

	componentWillMount() {
		const { isFundLoading, dispatch } = this.props;

		// Get the merchant funds amount
		if ( ! isFundLoading ) {
			dispatch(getCurrentUser());
		}
	}

	/**
	 * Render Main content
	 */
	render() {
		return (
			<div>
				<FundAmount />

				<Switch>
					<Route path="/funds/page/:page" component={PayoutHistory} />
					<Route path="/funds" component={PayoutHistory} />
				</Switch>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const { isLoading: isFundLoading } = state.user;

	return {
		isFundLoading
	};
}

export default withRouter(connect(mapStateToProps)(FundsPage));



// WEBPACK FOOTER //
// ./src/pages/Funds/index.js